<template>
  <div class="page-wrapper">
    <Header />
    <main class="page-main">
      <HeroHowWeWork />
      <EcosystemSection />
      <TechnicalSupportSection />
      <NetworkSection />
      <TrainFlowSection />
      <FinalCTASection />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import FinalCTASection from '../components/FinalCTASection.vue';
import Footer from '../components/Footer.vue';
import HeroHowWeWork from '../components/HowWeWork/HeroHowWeWork.vue';
import EcosystemSection from '../components/HowWeWork/EcosystemSection.vue';
import TechnicalSupportSection from '../components/HowWeWork/TechnicalSupportSection.vue';
import NetworkSection from '../components/HowWeWork/NetworkSection.vue';
import TrainFlowSection from '../components/HowWeWork/TrainFlowSection.vue';

export default {
  components: {
    Header,
    HeroHowWeWork,
    EcosystemSection,
    TechnicalSupportSection,
    NetworkSection,
    TrainFlowSection,
    FinalCTASection,
    Footer
  }
};
</script>
